interface ErrorAlertProps {
  message: string
}

export function ErrorAlert({ message }: ErrorAlertProps) {
  return (
    <div className="bg-red-900/50 border border-red-700 rounded-md p-3">
      <p className="text-sm text-red-200">{message}</p>
    </div>
  )
}
